import { type UserRole, useMe } from '@/auth/useMe'

export type { UserRole }

/**
 * Fetch the current user's role from GET /api/v1/me (via {@link useMe}).
 *
 * UX only: the backend enforces RBAC with 403. Used to hide team-only UI from
 * founders so they don't hit a dead end.
 */
export function useRole(): { role: UserRole | null; loading: boolean } {
  const { me, loading } = useMe()
  return { role: me?.role ?? null, loading }
}
